var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"w-100",attrs:{"href":_vm.baseUrl + '/auth/twitter'}},[_c('v-img',{staticClass:"w-100 h-auto",attrs:{"src":require('@/assets/images/twitter_login.png'),"alt":"","srcset":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }